"use client";

import ChildrenHistoryPage from "@/app/dashboard/history/children/page";
import DoctorsHistoryPage from "@/app/dashboard/history/doctors/page";
import EmergencyHistoryPage from "@/app/dashboard/history/emergency/page";
import MarriageHistoryPageContent from "@/app/dashboard/history/marriage/MarriageHistoryPageContent";
import MedicationHistoryPage from "@/app/dashboard/history/medication/page";
import WorkHistoryPage from "@/app/dashboard/history/work/page";
import { Box } from "@chakra-ui/react";

const TemplateManager = ({
  template,
}: {
  template:
    | "current_marriage"
    | "prior_marriages"
    | "children"
    | "employment"
    | "doctor_visits"
    | "medications"
    | "contacts";
}) => {
  return (
    <Box w="100%">
      {(template === "current_marriage" || template === "prior_marriages") && (
        <MarriageHistoryPageContent application_template={template} />
      )}
      {template === "children" && <ChildrenHistoryPage />}
      {template === "employment" && <WorkHistoryPage />}
      {template === "doctor_visits" && <DoctorsHistoryPage />}
      {template === "medications" && <MedicationHistoryPage />}
      {template === "contacts" && <EmergencyHistoryPage />}
    </Box>
  );
};

export default TemplateManager;
